import { render, staticRenderFns } from "./TransactionsMonitor.vue?vue&type=template&id=3be97128&"
import script from "./TransactionsMonitor.vue?vue&type=script&lang=js&"
export * from "./TransactionsMonitor.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports